import { defineComponent, ref, watch, h, type PropType } from "vue";
import { router } from './index';

export default defineComponent({
  name: 'RouteName',
  props: {
    name: {
      type: String as PropType<string>,
      required: true,
    },
    params: {
      type: Object as PropType<Record<string, boolean | number | string>>,
      required: false,
    },
  },
  setup(props, { slots }) {
    const { route: myRoute, path } = router!.matchName(props.name, props.params);
    let elClass = ref({});

    watch([router?.currentRoute, router?.currentPath], () => {
      elClass.value = {
        'route': true,
        'route-active': myRoute ? router!.isActiveRoute(myRoute) : false,
        'route-hyper-active': router!.isCurrentPath(path),
      }
    }, { immediate: true });

    return () => {
      return h(
        'a',
        {
          onClick: (e) => { router!.dispatch({ name: props.name, params: props.params });; e.preventDefault(); },
          href: path,
          class: elClass.value,
        },
        slots.default && slots.default()
      );
    };
  },
});
